/* eslint-disable camelcase */
import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { NewRedirectIcon } from 'components/customicons/holdings';
import {
  TWENTY_FOUR_HOURS,
  FIFTEEN_MINUTES,
  ONE_HOUR,
  UNDER_MAINTENANCE_URL,
} from 'constants/constants';
import { TIME_FORMATS } from 'constants/timeformats';
import {
  dateFormat,
  getDateTime,
  getSeconds,
  startOf,
  timeNow,
  toLocal,
  toUTC,
} from 'helpers/day';
import { SmallInfo } from 'styles/assets/icons';

import styles from '../maintenanceBanner.module.scss';
import useMaintenance from '../useMaintenance';

export interface MaintenanceStripProps {
  isLoggedIn?: boolean;
  className?: string;
  showWhatToExpect?: boolean;
  isTopBanner?: boolean;
}

const DesktopView = (props: MaintenanceStripProps) => {
  const { t } = useTranslation(['common']);
  const {
    isLoggedIn,
    showBanner,
    setShowBanner,
    maintenanceStartTime,
    maintenanceFinishTime,
    isDatesEqual,
    maintenanceDuration,
    timeLeftToStartMaintenance,
    isVisibleToUsers,
    countdownRef,
    maintenance_start_time,
    maintenanceFinishTimeInMilliseconds,
    countdownTimer,
  } = useMaintenance();

  const setBannerVisibility = () => {
    if (timeLeftToStartMaintenance === null) return;

    if (maintenanceDuration && maintenanceDuration < ONE_HOUR) {
      if (
        timeLeftToStartMaintenance > 0 &&
        timeLeftToStartMaintenance <= TWENTY_FOUR_HOURS
      ) {
        setShowBanner(true);
      }
    } else if (maintenanceDuration && maintenanceDuration <= 4 * ONE_HOUR) {
      if (
        timeLeftToStartMaintenance > 0 &&
        timeLeftToStartMaintenance <= 2 * TWENTY_FOUR_HOURS
      ) {
        setShowBanner(true);
      }
    } else if (
      timeLeftToStartMaintenance > 0 &&
      timeLeftToStartMaintenance <= 3 * TWENTY_FOUR_HOURS
    ) {
      setShowBanner(true);
    }
  };

  useEffect(() => {
    setBannerVisibility();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maintenance_start_time, maintenanceDuration, countdownTimer]);

  const { isTopBanner, className, showWhatToExpect } = props;
  return showBanner && (isLoggedIn || isVisibleToUsers) ? (
    <div
      className={`${styles.maintenanceWrapper} ${isTopBanner ? styles.topBanner : ''} ${
        className || ''
      }`}
      data-palette="DesktopView">
      <div className={styles.desc}>
        <div className={styles.title}>
          <span className={styles.icon}>
            <SmallInfo className="info-icon" />
          </span>
          <span className={styles.heading}>
            {t('common:maintenance_notif_banner_new')}
            <span className="colon">:</span> {`  `}
          </span>
        </div>
        <div className={styles.text}>
          <div className={styles.timer}>
            {countdownRef.current &&
            countdownRef.current >= 0 &&
            countdownRef.current <= 2 * FIFTEEN_MINUTES ? (
              <span data-palette="DesktopView">
                {t('common:startsIn')}
                {dateFormat(
                  getSeconds(startOf(timeNow(), 'day'), countdownRef.current),
                  TIME_FORMATS.mmss
                )}
              </span>
            ) : (
              <span data-palette="DesktopView">
                {maintenanceStartTime}
                {` `}
                {!isDatesEqual ? t('common:to_small') : ' -'}{' '}
                {isDatesEqual
                  ? dateFormat(
                      toLocal(toUTC(getDateTime(maintenanceFinishTimeInMilliseconds))),
                      TIME_FORMATS.LT
                    )
                  : maintenanceFinishTime}{' '}
                ({new Intl.DateTimeFormat().resolvedOptions().timeZone})
              </span>
            )}
            {(isTopBanner || showWhatToExpect) && (
              <span
                className={`${styles.colorBlue} ${styles.redirectLink}`}
                data-palette="DesktopView">
                <a
                  data-testid="maintenance"
                  href={`${UNDER_MAINTENANCE_URL}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('common:what_to_expect')}
                  <NewRedirectIcon />
                </a>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default DesktopView;
